module.exports = __webpack_public_path__ + "static/changing_digital-c9f50c6b920e98699759df2b0debc38f.svg";